// Japanese pronunciation through the OS voices (iOS 12 ships "Kyoko"); no network needed.

const PREFERRED = ['kyoko', 'otoya', 'nanami', 'haruka', 'ayumi', 'mizuki'];

function japaneseVoice(): SpeechSynthesisVoice | null {
  const voices = window.speechSynthesis.getVoices().filter((v) => v.lang.toLowerCase().indexOf('ja') === 0);
  for (const name of PREFERRED) {
    const v = voices.find((x) => x.name.toLowerCase().indexOf(name) >= 0);
    if (v) return v;
  }
  return voices[0] || null;
}

export function canSpeak(): boolean {
  return typeof window !== 'undefined' && 'speechSynthesis' in window && typeof SpeechSynthesisUtterance !== 'undefined';
}

/** Speaks `text` in Japanese, interrupting anything already speaking. */
export function speakJapanese(text: string, onEnd?: () => void): void {
  if (!canSpeak()) return;
  const s = window.speechSynthesis;
  s.cancel();
  const u = new SpeechSynthesisUtterance(text);
  u.lang = 'ja-JP';
  u.rate = 0.9;
  const v = japaneseVoice();
  if (v) u.voice = v;
  if (onEnd) {
    u.onend = onEnd;
    u.onerror = onEnd;
  }
  s.speak(u);
}

export function stopSpeaking(): void {
  if (canSpeak()) window.speechSynthesis.cancel();
}
